import {PromotionTextTypes} from '~/utils/constants';

import instance from './instance';

export enum NotificationActionType {
  Button = 'button',
  AllPromoControl = 'all-promo-control',
}

export type ButtonLabel = 'edit_promo' | 'charge_balance' | 'pay_promo';

export interface ButtonPayload {
  url: string;
  label: ButtonLabel;
}

export interface PromoPayload {
  createdPromo: PromotionTextTypes;
}

export type NotificationPayloadMap = {
  [NotificationActionType.Button]: ButtonPayload;
  [NotificationActionType.AllPromoControl]: PromoPayload;
};

export interface TNotificationAction<T extends keyof NotificationPayloadMap> {
  type: T;
  payload: Pick<NotificationPayloadMap, T>;
}

export enum NotificationType {
  error = 'error',
  success = 'success',
  info = 'info',
}

export interface TNotification {
  id: number;
  title: string;
  content: string;
  added: string;
  actions: Array<
    TNotificationAction<NotificationActionType.Button | NotificationActionType.AllPromoControl>
  >;
  viewed?: string;
  type?: NotificationType;
  readed?: boolean;
}

export interface TNotificationsResponse {
  total: number;
  unviewed: number;
  items: TNotification[];
}

interface FetchUserNotificationsParams {
  offset?: number;
  limit?: number;
}

export const fetchUserNotifications = ({offset, limit}: FetchUserNotificationsParams = {}) =>
  instance.get<TNotificationsResponse>('/frontend/api/v1/notifications', {
    params: {
      offset,
      limit,
    },
  });

interface UpdateAllNotificationsResponse {
  count: number;
}

export const setUserNotificationAsReaded = (notificationId: number) =>
  instance.patch(`/frontend/api/v1/notifications/mark-as-read/${notificationId}`);

export const removeNotification = (notificationId: number) =>
  instance.delete(`/frontend/api/v1/notifications/${notificationId}`);

export const setAllUserNotificationsAsReaded = () =>
  instance.patch<UpdateAllNotificationsResponse>('/frontend/api/v1/notifications/mark-as-read-all');

export const removeAllNotifications = () =>
  instance.delete<UpdateAllNotificationsResponse>('/frontend/api/v1/notifications/delete-all');
